import React, { Component, PureComponent } from 'react'
import { observer } from 'mobx-react'
import Select from 'react-select'
import i18n from 'i18next'
import * as R from 'ramda'
import Switch from './formElements/Switch'

class DropdownList extends PureComponent {
    constructor(props) {
        super(props)
        const { question, store } = props
        const { form_data } = store
        const { id } = question

        this.selectedOption = form_data.has(id) ? form_data.get(id).data.value : 0

        const options = this.getOptions()

        this.state = {
            options,
            value: this.getDefaultOption(options),
        }

        if (question.settings.frontend.switch) {
            this.switchValue = question.settings.frontend.switch[0]
        } else {
            this.switchValue = undefined
        }

        this.multiple = Object.hasOwnProperty.call(question, 'multiple') ? question.multiple : false
    }

    getOptions = () => {
        const { question } = this.props
        const { optionSet } = question

        return optionSet.options
            .filter((option) => !option.isHidden)
            .map((option) => (
                {
                    value: option.id,
                    label: this.getText(option),
                }
            ))
    }

    getDefaultOption = (options) => (
        this.selectedOption
            ? options.find((option) => option.value === this.selectedOption)
            : null
    )

    handleChange = (valueObj) => {
        const { question, store, formId } = this.props
        if (question.required) {
            if (valueObj && valueObj.value !== 0) {
                store.addFormResponse(question, {
                    value: valueObj.value,
                    formId,
                    switch: this.switchValue,
                })
            }
        } else {
            const value = valueObj ? valueObj.value : 0
            store.addFormResponse(question, {
                value,
                formId,
                switch: this.switchValue,
            })
        }
        this.selectedOption = R.pathOr(null, ['value'])(valueObj)
        this.setState({
            value: valueObj,
        })
    }

    changeSwitch = (e) => {
        const { question, store } = this.props
        const { form_data, langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const questionId = question.id
        const { checked } = e.target
        const switchValue = checked
            ? question.settings.frontend.switch[1]
            : question.settings.frontend.switch[0]

        let localeLabel = ''
        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }

        this.switchValue = localeLabel

        if (form_data.has(questionId)) {
            const { data } = form_data.get(questionId)
            data.switch = localeLabel
            store.addFormResponse(question, data)
        }
    }

    getSwitchLabel = (target) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const index = target === 'left'
            ? 0
            : 1

        const switchValue = question.settings.frontend.switch[index]

        let localeLabel = ''
        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }

        return localeLabel
    }

    componentDidUpdate(prevProps) {
        if (prevProps.langCode !== this.props.langCode) {
            const options = this.getOptions()
            this.setState({
                options,
                value: this.getDefaultOption(options),
            })
        }
    }

    getText = (option) => {
        const { question, store, langCode } = this.props
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        console.log(JSON.stringify(option.langs), langCode, defaultLocale)
        let text = ''
        if (option.langs[langCode]) {
            ({ text } = option.langs[langCode])
        } else if (option.langs[defaultLocale]) {
            ({ text } = option.langs[defaultLocale])
        } else if (option.langs[initialLocale]) {
            ({ text } = option.langs[initialLocale])
        }
        text = text.replace(/&amp;/gi, '&')
        return text
    }

    getDropStyle = () => {
        const { question } = this.props
        const hasSwitch = question.settings.frontend.switch
        let style = {}
        if (hasSwitch) {
            style = {
                flex: 1,
            }
        }
        return style
    }

    render() {
        const { question, store, validationMsg } = this.props
        const { form_data } = store
        const name = `SB_${question.id}`
        const questionId = question.id
        const data = form_data.has(questionId) ? form_data.get(questionId).data : {}

        return (
            <div className={`SB ${question.settings.frontend.switch ? 'switch' : ''}`}>
                <Select
                    classNamePrefix="dropdownlist"
                    name={name}
                    id={name}
                    // defaultValue={this.getDefaultOption(options)}
                    value={this.state.value}
                    options={this.state.options}
                    onChange={this.handleChange}
                    placeholder={i18n.t('general.pleaseSelect')}
                    isMulti={this.multiple}
                    isSearchable={true}
                    isClearable={!question.isMandatory}
                    // menuIsOpen={true}
                />
                {validationMsg}
                {question.settings.frontend.switch && (
                    <Switch
                        onChange={this.changeSwitch}
                        value={data.switch}
                        left={this.getSwitchLabel('left')}
                        right={this.getSwitchLabel('right')}
                    />
                )}
            </div>
        )
    }
}

export default DropdownList
